import { Dispatch, SetStateAction } from 'react'
import { EntityType } from '../backend/types/entity.ts'
import defaultDiagramConfig from "../configs/diagram.json"
import { DiagramConfig, EntityConfig } from '../types/diagram.ts'
import { useLocalStorage } from './useLocalStorage.ts'

export const useDiagramConfig = (): {
    config: DiagramConfig,
    setConfig: Dispatch<SetStateAction<DiagramConfig>>,
    resetConfig: () => void,
    getEntityConfigOrDefault: (type: EntityType) => EntityConfig
} => {
    const [storageDiagramConfig, setLocalStorageConfig] =
        useLocalStorage<DiagramConfig>('diagramConfig', defaultDiagramConfig)

    const resetDiagramConfig = () => {
        setLocalStorageConfig(() => defaultDiagramConfig)
    }

    const getEntityStylePropertyOrDefault = (type: EntityType) =>
        storageDiagramConfig.entities[type] || storageDiagramConfig.defaultEntity

    const migrateConfig = (targetConfigObj: object, sourceConfigObj: object) => {
        Object.keys(sourceConfigObj).forEach((key) => {
            const configKey = key

            if (!(configKey in targetConfigObj)) {
                // @ts-expect-error types-not-match
                targetConfigObj[configKey] = sourceConfigObj[configKey]
            }
        })
    }

    migrateConfig(storageDiagramConfig, defaultDiagramConfig)
    migrateConfig(storageDiagramConfig.entities, defaultDiagramConfig.entities)
    Object.entries(defaultDiagramConfig.entities).forEach(([key, config]) => {
        const entityConfig = storageDiagramConfig.entities[key as EntityType]
        if (entityConfig) {
            migrateConfig(entityConfig, config)
        }
    })
    migrateConfig(storageDiagramConfig.linkAmountText, defaultDiagramConfig.linkAmountText)
    migrateConfig(storageDiagramConfig.defaultEntity, defaultDiagramConfig.defaultEntity)
    migrateConfig(storageDiagramConfig.linkLabelText, defaultDiagramConfig.linkLabelText)
    migrateConfig(storageDiagramConfig.selected, defaultDiagramConfig.selected)

    return {
        config: storageDiagramConfig,
        setConfig: setLocalStorageConfig,
        resetConfig: resetDiagramConfig,
        getEntityConfigOrDefault:
        getEntityStylePropertyOrDefault
    }
}
